// 2026 Topps Star Wars The National (NSCC Collection) — authored by hand (2026-08-05)
// =============================================================================
// Source: official Topps "2026 National Sports Collectors Convention" checklist
// PDF (Star Wars box only: base SW-1..SW-50 + 38-card autograph parallel,
// plus the five Star Wars subjects of the National Collection insert).
// Parallel ladder + print runs verified against the published NSCC Collection
// checklist (Refractor base; Gold /50, NSCC Annual /26, Orange /25 + Ray Wave,
// Black /10 + Ray Wave, Red /5 + Ray Wave, Superfractor 1/1; autographs are
// unnumbered Refractors with Black /10, Red /5, Superfractor 1/1 parallels).
// Rule 7: the autograph base Refractor is unnumbered, so no base serial slot.
// =============================================================================

export const SETS = [
  {
    id: "base",
    type: "base",
    title: "BASE",
    parallels: [
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "nscc-annual-refractor", name: "NSCC Annual Refractor", print_run: 26, color: "#e8e8ec" },
        { id: "orange-refractor", name: "Orange Refractor", print_run: 25, color: "#ff9100" },
        { id: "orange-ray-wave-refractor", name: "Orange Ray Wave Refractor", print_run: 25, color: "#ffb072" },
        { id: "black-refractor", name: "Black Refractor", print_run: 10, color: "#a8a8b4" },
        { id: "black-ray-wave-refractor", name: "Black Ray Wave Refractor", print_run: 10, color: "#c0c4d4" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "red-ray-wave-refractor", name: "Red Ray Wave Refractor", print_run: 5, color: "#ff9090" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SW-1", name: "Warwick Davis Wicket W. Warrick" },
        { n: "SW-2", name: "John Boyega Finn" },
        { n: "SW-3", name: "Simon Pegg Unkar Plutt" },
        { n: "SW-4", name: "Billy Dee Williams Lando Calrissian" },
        { n: "SW-5", name: "Ewan McGregor Obi-Wan Kenobi" },
        { n: "SW-6", name: "Rosario Dawson Ahsoka Tano" },
        { n: "SW-7", name: "Lee-Jung Jae Jedi Master Sol" },
        { n: "SW-8", name: "Billie Lourd Kaydel Connix" },
        { n: "SW-9", name: "Taika Waititi IG-12" },
        { n: "SW-10", name: "Steve Blum Garazeb Orrelios" },
        { n: "SW-11", name: "Paul Bettany Dryden Vos" },
        { n: "SW-12", name: "Katee Sackhoff Bo-Katan Kryze" },
        { n: "SW-13", name: "Ming-Na Wen Fennec Shand" },
        { n: "SW-14", name: "Oscar Isaac Poe Dameron" },
        { n: "SW-15", name: "Forest Whitaker Saw Gerrera" },
        { n: "SW-16", name: "Lupita Nyong'o Maz Kanata" },
        { n: "SW-17", name: "David Barclay Jabba the Hutt" },
        { n: "SW-18", name: "Keri Russell Zorii Bliss" },
        { n: "SW-19", name: "Hayden Christensen Darth Vader" },
        { n: "SW-20", name: "Laura Dern Amilyn Holdo" },
        { n: "SW-21", name: "Joel Edgerton Owen Lars" },
        { n: "SW-22", name: "Fred Tatascoire Captain Brutus" },
        { n: "SW-23", name: "Diego Luna Cassian Andor" },
        { n: "SW-24", name: "Samuel L. Jackson Mace Windu" },
        { n: "SW-25", name: "Genevieve O'Reilly Mon Mothma" },
        { n: "SW-26", name: "Temuera Morrison Boba Fett" },
        { n: "SW-27", name: "Harrison Ford Han Solo" },
        { n: "SW-28", name: "Adam Driver Kylo Ren" },
        { n: "SW-29", name: "Daisy Ridley Rey" },
        { n: "SW-30", name: "Jude Law Jod Na Nawood" },
        { n: "SW-31", name: "Ian McDiarmid Darth Sidious" },
        { n: "SW-32", name: "Anthony Daniels C-3PO" },
        { n: "SW-33", name: "Emilia Clarke Qi'ra" },
        { n: "SW-34", name: "Mark Hamill Luke Skywalker" },
        { n: "SW-35", name: "Natalie Portman Padmé Amidala" },
        { n: "SW-36", name: "Peter Mayhew Chewbacca" },
        { n: "SW-37", name: "Hayden Christensen Anakin Skywalker" },
        { n: "SW-38", name: "Pedro Pascal The Mandalorian" },
        { n: "SW-39", name: "R2-D2" },
        { n: "SW-40", name: "Count Dooku" },
        { n: "SW-41", name: "Grogu" },
        { n: "SW-42", name: "Stormtrooper" },
        { n: "SW-43", name: "Robert Timothy Smith Neel" },
        { n: "SW-44", name: "Alan Tudyk K-2SO" },
        { n: "SW-45", name: "Yoda" },
        { n: "SW-46", name: "Ray Park Darth Maul" },
        { n: "SW-47", name: "Carrie Fisher Leia Organa" },
        { n: "SW-48", name: "Ivanna Sakhno Shin Hati" },
        { n: "SW-49", name: "Natasha Liu Bordizzo Sabine Wren" },
        { n: "SW-50", name: "Liam Neeson Qui-Gon Jinn" },
    ],
  },
  {
    id: "autographs",
    type: "auto",
    title: "AUTOGRAPHS",
    parallels: [
        { id: "black-refractor", name: "Black Refractor", print_run: 10, color: "#a8a8b4" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SW-01", name: "Warwick Davis Wicket W. Warrick" },
        { n: "SW-02", name: "John Boyega Finn" },
        { n: "SW-03", name: "Simon Pegg Unkar Plutt" },
        { n: "SW-04", name: "Billy Dee Williams Lando Calrissian" },
        { n: "SW-05", name: "Ewan McGregor Obi-Wan Kenobi" },
        { n: "SW-06", name: "Rosario Dawson Ahsoka Tano" },
        { n: "SW-07", name: "Lee-Jung Jae Jedi Master Sol" },
        { n: "SW-08", name: "Billie Lourd Kaydel Connix" },
        { n: "SW-09", name: "Taika Waititi IG-12" },
        { n: "SW-10", name: "Steve Blum Garazeb Orrelios" },
        { n: "SW-11", name: "Paul Bettany Dryden Vos" },
        { n: "SW-12", name: "Katee Sackhoff Bo-Katan Kryze" },
        { n: "SW-13", name: "Ming-Na Wen Fennec Shand" },
        { n: "SW-14", name: "Oscar Isaac Poe Dameron" },
        { n: "SW-15", name: "Forest Whitaker Saw Gerrera" },
        { n: "SW-16", name: "Lupita Nyong'o Maz Kanata" },
        { n: "SW-18", name: "Keri Russell Zorii Bliss" },
        { n: "SW-19", name: "Hayden Christensen Darth Vader" },
        { n: "SW-20", name: "Laura Dern Amilyn Holdo" },
        { n: "SW-21", name: "Joel Edgerton Owen Lars" },
        { n: "SW-22", name: "Fred Tatascoire Captain Brutus" },
        { n: "SW-23", name: "Diego Luna Cassian Andor" },
        { n: "SW-24", name: "Samuel L. Jackson Mace Windu" },
        { n: "SW-25", name: "Genevieve O'Reilly Mon Mothma" },
        { n: "SW-26", name: "Temuera Morrison Boba Fett" },
        { n: "SW-27", name: "Harrison Ford Han Solo" },
        { n: "SW-28", name: "Adam Driver Kylo Ren" },
        { n: "SW-29", name: "Daisy Ridley Rey" },
        { n: "SW-30", name: "Jude Law Jod Na Nawood" },
        { n: "SW-31", name: "Ian McDiarmid Darth Sidious" },
        { n: "SW-32", name: "Anthony Daniels C-3PO" },
        { n: "SW-33", name: "Emilia Clarke Qi'ra" },
        { n: "SW-34", name: "Mark Hamill Luke Skywalker" },
        { n: "SW-35", name: "Natalie Portman Padmé Amidala" },
        { n: "SW-36", name: "Peter Mayhew Chewbacca" },
        { n: "SW-37", name: "Hayden Christensen Anakin Skywalker" },
        { n: "SW-38", name: "Pedro Pascal The Mandalorian" },
        { n: "SW-44", name: "Alan Tudyk K-2SO" },
    ],
  },
  // THE NATIONAL COLLECTION is a 30-card cross-sport insert spanning all six
  // NSCC Collection boxes; only its five Star Wars subjects (NC-26..NC-30) are
  // listed here. Insert exists as Refractor + Superfractor 1/1 only; the
  // autograph parallel shares the standard auto tiers.
  {
    id: "national-collection",
    type: "insert",
    title: "THE NATIONAL COLLECTION",
    parallels: [
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "NC-26", name: "Ahsoka Tano" },
        { n: "NC-27", name: "Queen Amidala" },
        { n: "NC-28", name: "The Mandalorian" },
        { n: "NC-29", name: "Han Solo" },
        { n: "NC-30", name: "Luke Skywalker" },
    ],
  },
  {
    id: "national-collection-autographs",
    type: "auto",
    title: "THE NATIONAL COLLECTION AUTOGRAPHS",
    parallels: [
        { id: "black-refractor", name: "Black Refractor", print_run: 10, color: "#a8a8b4" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "NC-26", name: "Rosario Dawson Ahsoka Tano" },
        { n: "NC-27", name: "Natalie Portman Queen Amidala" },
        { n: "NC-28", name: "Pedro Pascal The Mandalorian" },
        { n: "NC-29", name: "Harrison Ford Han Solo" },
        { n: "NC-30", name: "Mark Hamill Luke Skywalker" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
